import api from "./api";

export const authService = {
  // Step 1 — Validate email/password and trigger OTP email.
  // Returns { otp_required: true, email } on success; throws on bad credentials.
  // turnstileToken: the cf-turnstile-response value from the widget (required).
  async login(email, password, turnstileToken) {
    try {
      // Get CSRF cookie first (Sanctum requirement)
      await api.get("/sanctum/csrf-cookie");

      const response = await api.post("/api/mobile/auth/login", {
        email,
        password,
        ...(turnstileToken
          ? { cf_turnstile_response: turnstileToken }
          : {}),
      });
      return response.data; // { message, otp_required: true, email }
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  },

  // Step 2 — Verify the OTP.
  // Returns { token, user } on success; throws on wrong/expired OTP.
  async verifyOtp(email, otp) {
    const response = await api.post("/api/mobile/auth/verify-otp", {
      email,
      otp,
    });
    return response.data; // { token, user }
  },

  // Request a fresh OTP (called when the user clicks "Resend OTP").
  async resendOtp(email) {
    const response = await api.post("/api/mobile/auth/resend-otp", { email });
    return response.data;
  },

  // Logout
  async logout() {
    const response = await api.post("/logout");
    return response.data;
  },

  // Get current user
  async getUser() {
    const response = await api.get("/api/mobile/auth/user");
    return response.data;
  },

  // Get user roles and products
  async getRolesAndProducts() {
    const response = await api.get("/api/mobile/user/roles-and-products");
    return response.data;
  },
};

